import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, CardBlock, Row, Col } from 'reactstrap';
import moment from 'moment';
import { Table, Input, Button, Modal, DatePicker, Select } from 'antd';
// import Pagination from 'rc-pagination';
// import moment from 'moment';
// import Select from 'react-select';
// import { SERVER_URL } from './../../../../config/host';
import * as actionqueryTasks from './../../../../actions/queryTasks';

const url = 'http://bscqr.qtdatas.com/export/inventory'
const { RangePicker } = DatePicker;
const { Option } = Select;

@connect(
  state => ({
    queryTasksState: state.get('QueryTasks')
  }),
  dispatch => ({
    queryTasksAction: bindActionCreators(actionqueryTasks, dispatch)
  })
)

export default class queryTasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      code: '',
      taskList: {},
      taskList1: [],
      display: 'none',
      loading: false,
      backgroundcolor: '#eee',
      color: '#232324',
      page1: 1,
      limit1: '5',
      date: '',
      type: '自建任务',
      status: ''
    };
  }
  state = { visible: false }
  componentWillMount() {
    const { queryTasksAction } = this.props;
    queryTasksAction.fetchGetTasks({ page: this.state.page, limit: this.state.limit, code: this.state.code, jobType: this.state.type })
      .then(() => { this.handleData(); });
  }
  // props 改变时调用
  componentWillReceiveProps() {
    // const { queryTasksState } = nextProps;
    // const { data } = (queryTasksState && queryTasksState.toJS().data) || {};
    // const exportData = (scoreState && scoreState.toJS().export.data) || {};
    // this.setState({ userName: data, exportData: exportData });
  }
  // 所有的任务列表数据
  handleData = (page) => {
    const { queryTasksState } = this.props;
    const { data } = queryTasksState.toJS().data || {};
    this.setState({ page, taskList: data });
  }
  search = () => {
    this.setState({ page: 1 });
    this.pageChange1(1);
  }
  pageChange = (page) => {
    const that = this;
    // this.setState({ page2: page })
    const { id, limit1 } = this.state;
    const { queryTasksAction } = this.props;
    queryTasksAction.fetchGettaskDetails({ id: id, page: page, limit: limit1 })
      .then((e) => {
        that.setState({
          taskList1: e.payload.data.data,
          display: 'block',
          fileName: e.payload.data.data.fileName
        })
        if (!e.payload.data.data.fileName) {
          that.setState({
            // btnName: '报告生成中'
            backgroundcolor: '#eee',
            color: '#232324'
          })
        } else {
          that.setState({
            // btnName: '下载报告'
            backgroundcolor: '#1890ff',
            color: 'white'
          })
        }
      })
    // const { limit, code } = this.state;
    // const { queryTasksAction } = this.props;
    // queryTasksAction.fetchGettaskDetails({ page: page, limit: limit, code: code })
    //   .then(() => { this.handleData(); })
    // this.confirm()
  }

  typein = field => (e) => {
    this.setState({ [field]: e.target.value });
  }
  changeFiled = field => (e) => {
    this.setState({ [field]: e });
  }

  pageChange1 = (page) => {
    const { code, limit, date, type, status } = this.state;
    const { queryTasksAction } = this.props;
    const where = { page, limit };
    if (code) where.code = code;
    if (date) {
      where.strDate = moment(date[0]).format('YYYY-MM-DD');
      where.endDate = moment(date[1]).format('YYYY-MM-DD');
    }
    if (type) where.jobType = type;
    if (status) where.jobStatus = status;
    queryTasksAction.fetchGetTasks(where)
      .then(() => {
        this.handleData(page);
      })
  }
  confirm = (value) => {
    // console.log('----------------id------', value)
    const that = this;
    that.setState({
      id: value.id
    })
    const { queryTasksAction } = this.props;
    const { page1, limit1 } = this.state;
    queryTasksAction.fetchGettaskDetails({ id: value.id, page: page1, limit: limit1 })
      .then((e) => {
        // console.log('============', e.payload)
        that.setState({
          taskList1: e.payload.data.data,
          display: 'block',
          fileName: e.payload.data.data.fileName
        })
        if (!e.payload.data.data.fileName) {
          that.setState({
            // btnName: '报告生成中'
            backgroundcolor: '#eee',
            color: '#232324'
          })
        } else {
          that.setState({
            // btnName: '下载报告'
            backgroundcolor: '#1890ff',
            color: 'white'
          })
        }
      })
  }
  export = () => {
    const that = this
    // if (this.state.btnName === '报告生成中') {
    //   message.info('报告生成中，请耐心等待...')
    // }
    // if (this.state.btnName === '下载报告') {
    //   that.setState({
    //     loading: true,
    //     display: 'none'
    //   })
    // }
    if (this.state.backgroundcolor === '#1890ff') {
      that.setState({
        loading: true,
        display: 'none'
      })
    }
  }
  handleOk = () => {
    this.setState({
      loading: !this.state.loading
    });
  }
  handleCancel = () => {
    this.setState({
      loading: !this.state.loading
    });
  }
  closeModel = () => {
    this.setState({
      display: 'none'
    })
  }
  render() {
    const { taskList, taskList1, fileName } = this.state
    const columns = [
      { title: '经销商code', dataIndex: 'userCode' },
      { title: '经销商名称', dataIndex: 'customer' },
      { title: '任务名称', dataIndex: 'name' },
      { title: '任务类型', dataIndex: 'type' },
      { title: '任务状态', dataIndex: 'status' },
      { title: '任务创建时间', dataIndex: 'createdAt' },
      { title: '操作', dataIndex: 'operator', render: (text, record) => <Button type="primary" onClick={() => this.confirm(record)}>查看详情</Button> }];
    const columns1 = [
      { title: '任务开始时间', dataIndex: 'strDate', },
      { title: '任务结束时间', dataIndex: 'endDate', },
      { title: '用户名', dataIndex: 'user.username', render: (text, record) => <div>{record.user.username}</div> },
      { title: '手机号', dataIndex: 'user.phone', render: (text, record) => <div>{record.user.phone}</div> },
      { title: 'QR数量', dataIndex: 'count' },
      { title: '状态', dataIndex: 'status' }]
    return (
      <Card>
        <CardBlock>
          <Row className="form-group">
            <Col md="12">
              <div className="input-group">
                <Col md="1">
                  <Input
                    style={{ width: 120 }}
                    placeholder="搜索code"
                    onChange={this.typein('code')}
                  />
                </Col>
                <Col md="2">
                  <RangePicker style={{ width: 250 }} onChange={this.changeFiled('date')} />
                </Col>
                <Col md="1">
                  <Select defaultValue="自建任务" style={{ width: 120 }} onChange={this.changeFiled('type')}>
                    <Option value="自建任务">内部盘点</Option>
                    <Option value="波科任务">波科盘点</Option>
                  </Select>
                </Col>
                <Col md="1">
                  <Select placeholder="任务状态" style={{ width: 120 }} onChange={this.changeFiled('status')}>
                    <Option value="unStart">未开始</Option>
                    <Option value="start">已开始</Option>
                    <Option value="submit">已提交</Option>
                    <Option value="finish">已完成</Option>
                    <Option value="expired">已超时</Option>
                  </Select>
                </Col>
                <Col md="2">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.search} className="btn btn-primary btn-pointer"><i className="fa fa-search" /> 查询</button>
                  </span>
                </Col>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Table
                bordered
                columns={columns}
                dataSource={taskList.docs}
                rowKey="id"
                showHeader
                size="middle"
                pagination={{
                  total: taskList.pages * 10,
                  pageSize: this.state.limit,
                  current: this.state.page,
                  onChange: this.pageChange1
                }}
              />
              <div style={{ background: 'rgba(187,187,187, 0.5)', position: 'fixed', textAlign: 'center', left: '0px', top: '0px', width: '100%', height: '100%', display: this.state.display }}>
                <div style={{ width: '800px', position: 'relative', margin: '9% auto', background: '#fff' }}>
                  <div style={{ height: '40px', textAlign: 'left' }}>
                    <h style={{ paddingLeft: '20px', lineHeight: '40px' }}>详情</h>
                    <h style={{ paddingLeft: '90%', fontSize: '25px' }} onClick={this.closeModel}>×</h>
                  </div>
                  <div style={{ margin: 'auto 10px' }}>
                    <Table
                      bordered
                      columns={columns1}
                      dataSource={taskList1.docs}
                      rowKey="id"
                      showHeader
                      size="middle"
                      pagination={{
                        total: taskList1.total,
                        pageSize: this.state.limit1,
                        onChange: this.pageChange
                      }}
                    />
                  </div>
                  <Button style={{ margin: '20px 85%', backgroundColor: this.state.backgroundcolor, border: '1px solid #fff', fontSize: '12px', color: this.state.color }} onClick={this.export}>下载报告</Button>
                </div>
              </div>
              <Modal
                visible={this.state.loading}
                closable="false"
                title="提示"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
              >
                <p>导出成功,请长按地址在浏览器打开</p>
                <p>{url}/{fileName}</p>
              </Modal>
            </Col>
          </Row>
        </CardBlock>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App/Tasks/queryTasks/index.js